import { Link } from "react-router-dom";
import { MANAGEMENT_PROFILES } from "../data/company-content";
import { CompanyTabs } from "../components/CompanyTabs";
import SEO from "@/components/SEO";

export default function CompanyLeadership() {
  return (
    <>
      <SEO
        title="Leadership | Motosport Software"
        description="Meet the leadership team behind Motosport Software and our vision for modern automotive and powersports workflows."
        url="https://motosportsoftware.com/company/leadership"
      />
      <main className="mx-auto max-w-6xl px-4 py-12 sm:px-6">
        <CompanyTabs currentTab="leadership" />
        <div className="mt-6">
          <h2 className="mb-4 text-[30px] font-[800] leading-[36px] tracking-tight text-[#1F2A3A]">
            Leadership Experience
          </h2>
          <p className="mb-4 text-[15px] leading-[24px] text-[#525A68]">
            Our co-founders bring complementary experience across software engineering, automotive
            retail, process improvement, artificial intelligence, enterprise systems, sales, and
            business development.
          </p>

          <div className="mt-2 flex flex-col gap-3">
            {MANAGEMENT_PROFILES.map((profile) => (
              <div
                key={profile.name}
                className="flex flex-row items-start gap-4 rounded-2xl border border-[#EDEBE4] bg-[#FAF8F3] p-4 sm:p-[18px]"
              >
                <img
                  src={profile.imagePath}
                  alt={`${profile.name}, ${profile.title}`}
                  width={92}
                  height={112}
                  loading="lazy"
                  decoding="async"
                  className="h-[112px] w-[92px] flex-shrink-0 rounded-xl object-cover"
                />

                <div className="flex min-w-0 flex-1 flex-col items-start text-left">
                  <p className="text-[17px] font-[800] leading-[22px] text-[#1F2A3A]">
                    {profile.name}
                  </p>
                  <p className="mt-0.5 text-[16px] font-[700] leading-[21px] text-[#BC0319]">
                    {profile.title}
                  </p>
                  <p
                    className="mt-1.5 text-[14px] leading-[21px] text-[#525A68]"
                    dangerouslySetInnerHTML={{ __html: profile.summary }}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </main>
    </>
  );
}
